import { Flex, FlexProps } from '@codedazur/react-components'
import styled from 'styled-components'

export const FlexInline = styled(Flex).attrs({
	crossAxisAlignment: 'center',
	as: 'span',
})<FlexProps>`
	display: inline-flex;
`
